import * as React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Onde fica localizado o estúdio da ITC+?",
  answer: "Nosso estúdio premium está estrategicamente localizado no coração de São Paulo, entre Pinheiros e a Faria Lima, facilitando o acesso para empresas e profissionais que buscam conveniência e infraestrutura de ponta."
}, {
  question: "Quais tipos de vídeos a produtora realiza?",
  answer: "Somos especialistas em vídeos corporativos estratégicos, treinamentos, vídeos para redes sociais com foco em conversão e produções audiovisuais completas que fortalecem o posicionamento da sua marca no mercado."
}, {
  question: "O estúdio de podcast já inclui edição?",
  answer: "Sim, oferecemos pacotes completos que vão desde a gravação com equipamentos profissionais de áudio e vídeo até a edição final, cortes para redes sociais (reels/shorts) e entrega pronta para publicação."
}, {
  question: "Como funciona o serviço de tráfego pago?",
  answer: "Aliamos a produção de conteúdo audiovisual de alta qualidade com estratégias de anúncios no Google e Meta Ads. O foco é garantir que seu vídeo chegue ao público certo para gerar leads e vendas reais."
}, {
  question: "É necessário agendar uma visita técnica?",
  answer: "Recomendamos o agendamento para que possamos apresentar nossa estrutura de iluminação, isolamento acústico e cenários. Você pode falar com um especialista agora mesmo pelo nosso canal de atendimento."
}];
export default function CommonInquiries() {
  return <section data-section-id="221810" id="dúvidas-frequentes" className="bg-background text-foreground section">
      <div className="container mx-auto px-6 md:px-12 max-w-4xl">
        <div className="mb-16 md:mb-24">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl text-foreground tracking-tighter">
            Dúvidas Frequentes
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border py-2">
              <AccordionTrigger className="[&>svg:last-child]:hidden group hover:no-underline py-6 md:py-8">
                <span className="font-default text-2xl md:text-3xl text-foreground font-semibold text-left pr-8 leading-tight">
                  {faq.question}
                </span>
                <Plus className="size-6 md:size-8 shrink-0 text-primary transition-transform duration-300 group-data-[state=open]:rotate-45 group-data-[state=open]:text-primary" />
              </AccordionTrigger>
              <AccordionContent className="font-default text-base md:text-lg text-muted-foreground leading-relaxed pb-8 md:pb-10 pr-12 md:pr-24">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}